module.exports = __webpack_public_path__ + "img/res7.916f8b07.png";